// @ts-nocheck
// Attention strip above a live-calls board: long ringing, long hold, long
// queue wait, transfer in flight. Clicking an alert selects that call.
import React from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
import type { LiveCallAlert } from '../liveCallsModel';

const ALERT_STYLE = {
  warn: 'bg-amber-500 text-amber-950 ring-amber-600 hover:bg-amber-400 dark:bg-amber-400 dark:text-amber-950',
  crit: 'bg-red-600 text-white ring-red-700 hover:bg-red-500 dark:bg-red-500 dark:text-white',
};

export default function LiveCallsAlertsBar({ alerts, onPick }: { alerts: LiveCallAlert[]; onPick?: (callId: string) => void }) {
  if (!alerts.length) {
    return (
      <p className="text-[11px] text-muted-foreground">
        No alerts · ring &gt; 8 s, hold &gt; 45 s, queue &gt; 60 s, transfer in progress
      </p>
    );
  }
  return (
    <div className="flex flex-wrap gap-1.5">
      {alerts.map((a) => (
        <button
          key={a.id}
          type="button"
          onClick={() => onPick?.(a.callId)}
          className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-left text-xs font-semibold shadow-sm ring-1 transition-colors ${ALERT_STYLE[a.tone] || ALERT_STYLE.warn}`}
        >
          {a.tone === 'crit' ? <AlertTriangle size={12} /> : <Clock size={12} />}
          {a.text}
        </button>
      ))}
    </div>
  );
}
